<div class="wrapper">
    <section class="section-container">
        <router-outlet></router-outlet>
    </section>
</div>
